import { Injectable } from '@angular/core';
import { NGXLogger as LoggerService } from 'ngx-logger';

/**
 * Embed-Mode: die App laeuft in einem iframe auf einer externen Seite
 * (typischerweise die Astro-Landing-Page via `<LiveDemoEmbed>`).
 *
 * Aktiviert via URL-Fragment `#embed` beim initialen Seiten-Aufruf. Ein Fragment
 * (statt des frueheren Query-Params `?embed=1`) sorgt dafuer, dass Google die
 * iframe-URL als identisch zur sauberen Canonical-URL behandelt — es entsteht keine
 * eigenstaendig indexierbare Embed-Duplikat-URL mehr. Das alte `?embed=1` wird aus
 * Abwaertskompatibilitaet weiterhin erkannt (bereits veroeffentlichte/gecachte Embeds).
 *
 * Im Embed-Mode wird die gesamte App-Chrome (Navbar, Cookie-Consent,
 * Language-Check-Popup, Sample-Banner, Feedback-Button) unterdrueckt und
 * Google Analytics komplett deaktiviert (kein Consent moeglich im iframe).
 *
 * Der Wert wird EINMALIG beim Modul-Laden aus der URL gelesen (s.u. `EMBED_AT_LOAD`),
 * bevor Angulars Router die URL normalisieren und das Fragment verwerfen kann. Er bleibt
 * fuer die gesamte SPA-Session konstant. Routerlinks erhalten Fragment/Param nicht
 * automatisch — das ist gewuenscht: der Copy-and-Edit-Flow soll die normale
 * App-Oberflaeche zeigen, nicht das embed-Layout.
 */

/**
 * Embed-Flag, erfasst zur Modul-Ladezeit (frueheste synchrone Stelle, noch vor Angulars
 * Router-Init). So geht das `#embed`-Fragment nicht verloren, falls der Router die URL
 * spaeter per replaceState ohne Fragment neu schreibt.
 */
const EMBED_AT_LOAD: boolean = (() => {
    if (typeof window === 'undefined') return false;
    try {
        if (window.location.hash.replace(/^#/, '') === 'embed') return true;
        return new URLSearchParams(window.location.search).get('embed') === '1';
    } catch (e) {
        return false;
    }
})();

@Injectable({
    providedIn: 'root'
})
export class EmbedModeService {
    public readonly isEmbedded: boolean = EMBED_AT_LOAD;

    constructor(private logger: LoggerService) {
        this.logger.log('EmbedModeService: isEmbedded =', this.isEmbedded);
    }
}
